import { ImportLayersElements } from '@/typings/layers/layers';
import { IFileParserStrategy } from '@/typings/parsers/externalFileParser';

export class FileParserContext<T> {
    private strategy: IFileParserStrategy<T>;

    constructor(strategy: IFileParserStrategy<T>) {
        this.strategy = strategy;
    }

    setStrategy(strategy: IFileParserStrategy<T>) {
        this.strategy = strategy;
    }

    async parseAndExtractLayers(
        buffer: ArrayBuffer,
        payload = {} as ImportLayersElements
    ): Promise<ImportLayersElements> {
        const parsedFile = await this.strategy.parse(buffer);
        return this.strategy.extractLayers(parsedFile, payload);
    }
}
